
import { useLocation } from 'react-router';

// eslint-disable-next-line import/prefer-default-export
export function useArchive() {
    const { pathname } = useLocation();
    return Boolean(pathname.extensions.contains('archive'));
}